/**
 * NOTIFICATION HANDLER constants
 */
export const NOTIFY = 'NOTIFY';
export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION';
export const HANDLE_ERROR = 'HANDLE_ERROR';
